/**
 * 全局配置
 * 所有与旧工程 hpcloud-html 对齐的常量集中在此，避免散落 magic string。
 */

/** 接口前缀，对应旧 common.js 的 contextPath = "/hp-cloud" */
export const API_BASE = import.meta.env.VITE_API_BASE || '/hp-cloud'

/** 旧工程上下文，用于 iframe 过渡页 */
export const LEGACY_CONTEXT = import.meta.env.VITE_LEGACY_CONTEXT || '/hp-cloud'

/** 是否允许未迁移页面回落到旧页面（iframe） */
export const ENABLE_LEGACY_FRAME = import.meta.env.VITE_ENABLE_LEGACY_FRAME === 'true'

export const APP_TITLE = import.meta.env.VITE_APP_TITLE || '充电桩运营平台'

/** sessionStorage / localStorage key —— 与旧工程保持一致，便于灰度期共存 */
export const STORAGE_KEYS = {
  /** 访问令牌，旧工程 key: hpcloudtoken */
  TOKEN: 'hpcloudtoken',
  /** 用户信息，旧工程 key: userInfo */
  USER_INFO: 'userInfo',
  /** 权限信息，旧工程 key: infoMap */
  INFO_MAP: 'infoMap',
  /** 菜单缓存，旧工程 key: menuContent / menuContent2 */
  MENU: 'menuContent',
  MENU2: 'menuContent2',
  /** 系统配置 */
  DOMAIN_NAME: 'domainName',
  COPY_RIGHT: 'copyRight',
  OFFICIAL_ACCOUNTS: 'officialAccounts',
  LOGO: 'logo',
  PC_MAINTENANCE_SWITCH: 'pcMaintenancSwitch'
} as const

/** 超级管理员角色值，对应旧 isSuperAdmin(): infoMap.userRoleValue == '99' */
export const SUPER_ADMIN_ROLE = '99'

/** 分页默认值，对齐旧 bootstrap-table 的 data-page-list / data-page-size */
export const PAGE_SIZES = [10, 20, 50, 100]
export const PAGE_SIZE = 15

/** 旧 bootstrap-table 的排序参数映射：order=asc/desc，orderName=字段名 */
export const SORT_ORDER = { ASC: 'asc', DESC: 'desc' } as const
